import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { label: '首页', href: '/' },
    { label: '作品全览', href: '/category/all' },
    { label: '最新动态', href: '/category/news' },
    { label: '关于我们', href: '/about' },
  ];

  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <h1 className={`font-heading text-xl font-bold transition-colors duration-300 ${
              isScrolled ? 'text-foreground-950' : 'text-white'
            }`}>
              佐佐木明希
            </h1>
            <span className={`hidden sm:inline text-xs px-2 py-0.5 rounded-full font-label transition-colors duration-300 ${
              isScrolled ? 'bg-primary-100 text-primary-700' : 'bg-white/20 text-white'
            }`}>
              FAN CLUB
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 rounded-full text-sm font-label transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(link.href)
                    ? isScrolled
                      ? 'bg-primary-500 text-white'
                      : 'bg-white/20 text-white'
                    : isScrolled
                      ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
              isScrolled ? 'text-foreground-800 hover:bg-background-200' : 'text-white hover:bg-white/10'
            }`}
            aria-label="打开菜单"
          >
            <i className={`text-lg ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3 px-4 animate-[fadeIn_0.2s_ease]">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`block px-4 py-3 rounded-lg text-sm font-label transition-colors mb-1 whitespace-nowrap cursor-pointer ${
                  isActive(link.href)
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}